var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-swipe',{attrs:{"autoplay":3000,"height":170,"indicator-color":'#1A3232'}},_vm._l((_vm.images),function(image,index){return _c('van-swipe-item',{key:index},[_c('img',{staticClass:"swiperImg",attrs:{"src":image}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }